/**
 * PortalNotFound — branded 404 for an unmatched route INSIDE the signed-in
 * portal shell (/app/*). Wired as `_layout.tsx`'s `notFoundComponent`.
 *
 * 2026-07-11 (first-touch rehearsal, finding #14): the rehearsal hit
 * `/app/people` (no such route — the cross-trust "people" surface only
 * exists per-trust at `/app/trusts/$id/people`) and got TanStack Router's
 * bare, unstyled `<p>Not Found</p>` fallback — no chrome, no message, no way
 * back in. The root `notFoundComponent` (`error-pages/not-found.tsx`) never
 * fires for a route nested under `/app`: TanStack resolves the nearest
 * matched ANCESTOR route as the not-found boundary, and `/app` had no
 * `notFoundComponent` of its own. Even if it had bubbled, the root fallback
 * renders the MARKETING chrome (Return home / Contact us) — wrong shell for
 * a signed-in session anyway. This renders the actual portal chrome
 * (sidebar + topbar via ScreenShell) with a plain-English message and a
 * link straight back to the dashboard, matching the empty-state card
 * styling used across the rest of the portal (e.g. the "no trust yet" card
 * on `/app/trusts`).
 */

import { Link } from '@tanstack/react-router';
import { ScreenShell } from '../screens/screen-shell';

export function PortalNotFound() {
  return (
    <ScreenShell eyebrow="Not found" title={<>We can&rsquo;t find that page</>}>
      <div className="card" style={{ padding: 24, maxWidth: 560 }}>
        <p style={{ color: 'var(--ink-3)', margin: '0 0 16px', lineHeight: 1.6 }}>
          The page you were looking for doesn&rsquo;t exist, or has moved.
          Nothing about your trust has changed. Your data is safe.
        </p>
        <Link
          to="/app/dashboard"
          style={{
            fontSize: 14.5,
            fontWeight: 600,
            color: 'var(--primary-600)',
            textDecoration: 'none',
            borderBottom: '1px solid rgba(31,77,69,0.25)',
            paddingBottom: 1,
          }}
        >
          Back to dashboard
        </Link>
      </div>
    </ScreenShell>
  );
}
